import Vue from 'vue';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
Vue.use(Loading);

export default Loading;


// WEBPACK FOOTER //
// ./src/libs/loadingOverlay.js